<template>
	<div>
		<div class="h3 ftw600">
			<!-- 我的筆記 -->
			{{$t('studentsCom.myNotes')}}
		</div>
		<div class="mt-3">
			<div class="flex alcenter">
				<div class="flex alcenter">
					<div class="ft16">
						{{$t('studentsCom.sortBy')}}
					</div>
					<a-select style="width: 180px;margin-left: 10px;" placeholder="请选择" v-model="search.sort" @change="getList">
						<a-select-option value="">{{$t('studentsCom.selectPlaceholder')}}</a-select-option>
						<a-select-option value="createtime desc">{{$t('studentsCom.sortDescOrEsc1')}}</a-select-option>
						<a-select-option value="createtime asc">{{$t('studentsCom.sortDescOrEsc2')}}</a-select-option>
						<a-select-option value="updatetime desc">{{$t('studentsCom.sortDescOrEsc3')}}</a-select-option>
						<a-select-option value="updatetime asc">{{$t('studentsCom.sortDescOrEsc4')}}</a-select-option>
					</a-select>
				</div>
				<div class="flex alcenter ms-4">
					<a-range-picker  valueFormat="YYYY-MM-DD" style="width: 300px;margin-left: 10px;" v-model="search.time"/>
					<div class="btn btn-theme ms-3" @click="getList()">
						{{$t('appointment.confirm')}}
					</div>
				</div>
				
			</div>
			<div class="bg-w p-4 br12 flex mt-3" style="width: 400px;" v-for="item in list">
				<img :src="item.teacher_info.photo_image" alt="" style="width: 55px;height: 55px;"
				v-if="item.teacher_info&&item.teacher_info.photo_image"/>
				<img src="../../../assets/image/staduents/notes.png" alt="" style="width: 55px;height: 55px;"
				 v-else />
				<div class="ml15" style="width: 100%;">
					<div class="cl-black ftw600 ft16 clickAct" @click="toTeacher(item.teacher_info.id)">
						{{item.teacher_info.name}}{{item.teacher_info.surname}}
					</div>
					<div class="mt-3 border-bottom pb-3">
						<div class="flex">
							<div style="width: 100px;">{{$t('studentsCom.classDate')}}</div>
							<div >{{item.start_time.substring(0,10)}}</div>
						</div>
						<div class="flex">
							<div style="width: 100px;">{{$t('forClassIndex.class')}}</div>
							<div>{{item.course_name}}</div>
						</div>
						<div class="flex">
							<div style="width: 100px;">{{$t('common.classID')}}</div>
							<div>{{item.course_id}}</div>
						</div>
					</div>
					<div :class="i==0?'mt-3':'mt-2'" v-for="(t,i) in item.reservation_order_appendix.status1" class="pb-3">
						<div class="flex justify-content-between alcenter" >
							<a :href="t.file" class="cl-theme ftw600 text-line-none over-hide" style="width: 240px;"> {{t.name}}</a>
							<!-- <div class="cl-info ft14">
								17.4KB
							</div> -->
						</div>
						<div class="mt-2 flex justify-content-between alcenter">
							<div class="">
								{{convertToTimeZone(t.createtime).formattedTime}}
							</div>
							<a href="#" class="cl-theme ftw600 text-line-none">{{$t('common.delete')}}</a>
						</div>
						<div class="mt-3 cl-black flex justify-content-between alcenter pb-3 border-b" >
							<div class="">
								初小數學
							</div>
							<div class="">
								{{$t('common.classID')}}:{{t.id}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="mt-3" >
			<a-pagination v-model:current="page" :total="totalCount" :defaultPageSize="2" show-less-items @change="getList()" />
		</div> -->
		
	</div>
</template>

<script>
	import uploadFile from "../../../components/upload/upload_file.vue"
	export default{
		components:{
			uploadFile
		},
		data(){
			return{
				page:1,
				list:[],
				totalCount:0,
				search:{
					time:[],
					sort:''
				}
			}
		},
		created(){
			this.getList()
		},
		methods:{
			toTeacher(id) {
				this.$router.push('/teacher?id=' + id);
			},
			getList(){
				this.$http.api('reservation/appendixList',{
					status:1,
					start_time:this.search.time.length!=0? this.search.time[0]+' 00:00:00' : '',
					finish_time:this.search.time.length!=0? this.search.time[1]+' 23:59:59' : '',
					order:this.search.sort
				}).then(res=>{
					this.list = res.list
				})
			}
		}
	}
</script>

<style>
</style>